/**
 * SortOption is a constant object that provides a set of predefined sorting options with corresponding labels and values.
 *
 * The available options include:
 *   - Relevance: Sort by relevance with a key value of '-relevance'.
 *   - Distance: Sort by distance with a key value of '-distance'.
 *   - Recent: Sort by recency with a key value of '-age'.
 *
 * @typedef {{label: string, value: string}} Sort
 * @type {Readonly<{string: Sort}>}
 * @enum
 */
export const SortOption = Object.freeze({
    Relevance: { label: 'Relevance', value: '-relevance' },
    Distance: { label: 'Distance', value: '-distance' },
    Recent: { label: 'Recent', value: '-age' }
});
